import React from "react";
import { useState, useEffect } from "react";

// Language Data
import koData from "../../../data/i18n/ko.json";
import jaData from "../../../data/i18n/ja.json";
import enData from "../../../data/i18n/en.json";

// SCSS
import "./WelcomeWindow.scss";

const WelcomeWindow = ({ lang }) => {
  // Language
  const langFiles = { ko: koData, ja: jaData, en: enData };
  const currentData = langFiles[lang] || koData;

  // Typing
  const [displayLines, setDisplayLines] = useState([]);

  useEffect(() => {
    const targetLines = currentData.terminal;
    let i = 0;
    let timer;

    setDisplayLines([]);

    const printLine = () => {
      if (i < targetLines.length) {
        const nextLine = targetLines[i];

        setDisplayLines((prev) => {
          if (
            prev.length > 0 &&
            prev[prev.length - 1] === nextLine &&
            nextLine !== ""
          ) {
            return prev;
          }
          return [...prev, nextLine];
        });

        i++;
        timer = setTimeout(printLine, 200);
      }
    };

    timer = setTimeout(printLine, 50);

    return () => {
      clearTimeout(timer);
      i = targetLines.length;
    };
  }, [lang]);

  // Window
  return (
    <div className="WelcomeWindow">
      {/* Section .Terminal */}
      <section className="Terminal">
        <div className="Terminal__Wrapper">
          <pre className="Terminal__Content">
            <code className="Terminal__Text">
              {displayLines.join("\n")}
              <span className="Terminal__Cursor" />
            </code>
          </pre>
        </div>
      </section>
    </div>
  );
};

export default WelcomeWindow;
